<script lang="ts">
	import Perks from './Perks.svelte';

	export let showCallToAction: boolean;
	export let isUsersPlan: boolean;
</script>

<div class="flex flex-col">
	<div
		class="w-[22rem] h-[36rem] p-8 flex flex-col justify-center items-center border
		bg-primary-50 border-primary-200 dark:border-zinc-800 dark:bg-zinc-900 rounded"
	>
		<div class="w-full flex flex-row justify-between items-center">
			<div class="w-fit text-zinc-900 dark:text-zinc-200 text-xl font-semibold">Free</div>
			{#if isUsersPlan}
				<div class="w-fit text-xs text-zinc-600">(your current plan)</div>
			{/if}
		</div>
		<div class="h-6"></div>
		<div class="w-full flex flex-col justify-start items-start">
			<Perks planName="Starter" checkmarkColor="text-cyan-600 dark:text-cyan-400 dark:opacity-80" />
		</div>
		<div class="h-8"></div>
		<div
			class="w-full h-12 flex flex-row justify-start items-center text-zinc-600 dark:text-zinc-200"
		>
			<div class="text-3.25xl font-semibold">$0</div>
		</div>
		<div class="h-6"></div>
		{#if isUsersPlan}
			<div class="flex flex-row justify-center items-center">
				<a
					class="w-fit h-12 px-6 flex flex-row justify-center items-center rounded font-semibold shadow-md
					text-zinc-900 bg-primary-50 border border-primary-200 hover:brightness-90
					dark:bg-zinc-300 dark:text-zinc-900 dark:hover:brightness-125"
					href="/canvas"
				>
					<i class="fas fa-paint-brush mr-2"></i> Go to canvas
				</a>
			</div>
		{:else if showCallToAction}
			<a
				class="w-48 h-12 flex flex-row justify-center items-center text-md
				font-semibold rounded shadow-md
				text-zinc-900 bg-primary-50 border border-primary-200 hover:brightness-90
				dark:text-zinc-900 dark:bg-zinc-300 dark:hover:brightness-125"
				href="/sign-up"
			>
				Try Free
			</a>
		{:else}
			<div
				class="w-48 h-12 flex flex-row justify-center items-center text-md rounded text-zinc-200"
			></div>
		{/if}
	</div>
</div>
